import {Injectable} from '@angular/core';
import {IModalOptions} from '../../common/modals/modal-options.interface';
import {EcaModalOptions} from '../../shared/models/yesno-modal-options.class';
import {LogItem} from '../models/log-item.class';
import {LogItemEditorModalComponent} from '../components/log-item-editor-modal/log-item-editor-modal.component';
import {EcaConfirmInfoModalOptions} from '../../shared/models/confirm-info-modal-options.class';
import {EcaConfirmProcessService} from '../../shared/services/eca-confirm-process.service';
import {BugLoggerService} from './bug-logger.service';
import {ErrorHandlingService} from '../../services/error-handling.service';
import {OurUserService} from '../../users/services/user.service';
import {IUserInfo} from '../../users/models/userInfo.interface';
import { EcaDynamicModalService } from "../../shared/services/eca-dynamic-modal-service";
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { IEcaDialogRef } from '../../shared/models/eca-dialog-ref.interface';

@Injectable({
  providedIn: 'root'
})

export class BugLoggerModalService {
  bugLogEditorModalRef: IEcaDialogRef;
  bugLogSettingsEditorModalRef: IEcaDialogRef;
  private loggedInUser: IUserInfo;

  constructor(private ecaDynamicModalService: EcaDynamicModalService,
              private bugLoggerService: BugLoggerService,
              private userService: OurUserService,
              private errorHandlingService: ErrorHandlingService,
              private confirmProcessService: EcaConfirmProcessService) {
    this.userService.getLoggedInUserSubject().subscribe(res => {
      this.loggedInUser = res;
    });
  }

  openLogItemEditorModal(logItem?: LogItem,
                         headerText?: string,
                         isNewLogItem: boolean = false,
                         options?: IModalOptions) {
    if (options === undefined) {
      options = new EcaModalOptions();
      options.modalClasses += ' modal-eca-success';
    }
    let isReadOnly;
    if (!logItem) {
      logItem = new LogItem();
      isReadOnly = false;
    } else {
      isReadOnly = true;
    }

    let config = {
      styleClass: 'modal-xl ' + options.modalClasses,
      baseZIndex: 2000,
      showHeader: false,
      header: headerText,
      data: {
        heading: headerText,
        logItem,
        isReadOnly
      }
    } as DynamicDialogConfig;

    this.bugLogEditorModalRef = this.ecaDynamicModalService.openDialog(LogItemEditorModalComponent,config);
    this.bugLogEditorModalRef?.content?.saveLogItemRequested.subscribe(documentUploadRequest => {
      if (documentUploadRequest) {
        this.bugLoggerService.saveOrCreateLogItem(documentUploadRequest).subscribe(res => {
          this.bugLogEditorModalRef?.dynamicDialogRef.close();
          if (res) {
            this.confirmProcessService.openConfirmProcessModal(`<p>Issue logged succesfully. </p>`, 'Issue logged succesfully',
              new EcaConfirmInfoModalOptions()).asObservable().subscribe(res2 => {
            });
          }
        }, error => {
        });
      }
    });
    this.bugLogEditorModalRef?.content?.cancelRequested.subscribe(cancelRequested => {
      this.bugLogEditorModalRef?.dynamicDialogRef.close();
    });
  }
}
